import { OffersList as SharedOffersList, type OffersListProps } from '@cx-web/components/page-template/OffersList';
import { captureException } from '@sentry/react-router';

// NGF-6397: the OffersList wrapper now lives in @cx-web/components (single source of truth, shared with
// atlas-astro). This thin RR7 glue carries the one host-specific concern the shared component can't:
//   - `onError`: the Sentry capture (@cx-web/components must not depend on @sentry/react-router).
//     Placed AFTER the `{...props}` spread so it always wins — `props` is the CMS-sourced
//     `componentArguments` and an `onError` key there must never shadow the Sentry capture.
// NGF-6300: the bare `clickoutServiceUrl` override is no longer read from the ambient global ENV here.
// The OFFERS_PAGE componentMap entry now passes it through props (sourced from
// ComponentLoaderContext.clickoutUrl), applied as the final override after the clickout contract spread
// so the bare URL still wins over `${CLICKOUT_URL}/offer/clickout`. atlas-astro applies the equivalent
// override in its island load(). Astro-island safe.
export const OffersList = (props: OffersListProps) => <SharedOffersList {...props} onError={captureException} />;

export type { OffersListProps };
